import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter } from "react-router-dom";

import { App } from "@/App";
import { ErrorBoundary } from "@/components/error-boundary";
import { ToastProvider } from "@/components/ui/toast";
import { startActivityTracking } from "@/lib/idle";
import { queryClient } from "@/lib/queryClient";
import { registerServiceWorker } from "@/lib/register-sw";

import "@/index.css";

// PWA / service worker — production only. See vite.config.ts for the
// runtime caching rules (spec §6.3).
registerServiceWorker();

// Feeds the idle timeout. Installed before render so the very first
// interaction counts, and never torn down — it lives as long as the tab.
startActivityTracking();

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found.");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
